
import { AWSFile } from "@/models/aws-file";
import { AWSFileService } from "@/services";
import AppPdfViewer from "@/components/common/PdfViewer.vue";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			blob: null as null | Blob,
			objUrl: ""
		};
	},
	props: {
		file: {
			type: Object as ()=>AWSFile,
			required: true
		}
	},
	computed: {
		isPdf():boolean {
			if (this.file.ContentType.indexOf("image") != -1){
				return false;
			}
			return this.file.ContentType.indexOf("pdf") != -1;
		}
	},
	async mounted(){
		this.blob = await AWSFileService.fetchFile(this.file.Token, this.file.Name, this.file.ContentType);
		this.objUrl = URL.createObjectURL(this.blob);
	},
	destroyed(){
		URL.revokeObjectURL(this.objUrl);
	},
	components: {
		AppPdfViewer
	}
});
